export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  date: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'learn-to-love-yourself-first',
    title: '学会狠狠爱自己，是一切爱的起点',
    excerpt: '当我们谈论"狠狠爱"的时候，很多人首先想到的是对他人的深情。但真正的爱，必须从自己开始。只有当你学会无条件地接纳自己、珍惜自己，你才能够以同样饱满的姿态去爱别人。',
    content: `<p>在这个快节奏的时代，我们常常忙于取悦他人、满足他人的期待，却忘了最重要的一件事——爱自己。</p>
<h2>什么是"狠狠爱自己"？</h2>
<p>"狠狠爱自己"不是自私，而是一种深刻的自我认知与接纳。它意味着你愿意花时间去了解自己内心真正的需求，勇敢地对自己说"我值得被爱"。</p>
<p>很多人把爱自己误解为放纵——买昂贵的物品、吃美味的食物、拒绝一切让自己不舒服的事情。但真正的爱自己，是在生理、心理和情感层面，都给予自己最温柔的照料。</p>
<h2>三个步骤，开始狠狠爱自己</h2>
<h3>第一步：停止自我批判</h3>
<p>我们内心常常住着一个苛刻的评判者，不断地挑剔自己的缺点和错误。狠狠爱自己的第一步，就是学会对那个声音说"够了"。接受自己的不完美，正如接受月亮有阴晴圆缺。</p>
<h3>第二步：建立健康的边界</h3>
<p>爱自己意味着懂得保护自己的时间和精力。学会说"不"，学会拒绝那些消耗你的人和事。这不是冷漠，而是对自己负责的表现。</p>
<h3>第三步：培养滋养自己的习惯</h3>
<p>每天留出至少30分钟，做一件纯粹让自己开心的事情。可以是一杯热茶、一段音乐、一场散步，或者只是安静地发呆。这些微小的仪式感，会在潜移默化中滋养你的灵魂。</p>
<h2>从今天开始</h2>
<p>不要去等待一个"完美的自己"，现在的你，就已经值得被狠狠爱着。对着镜子里的自己微笑，真诚地说一句："我爱你，我会一直陪伴你。"</p>
<p>狠狠爱自己，是你能给自己最好的礼物，也是你能给这个世界最大的贡献。因为一个内心充盈着爱的人，自然会把这份爱传递给身边的每一个人。</p>`,
    category: 'love-yourself',
    categoryName: '狠狠爱自己',
    author: '小雨',
    date: '2026-07-15',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20serene%20and%20warm%20scene%20of%20a%20person%20sitting%20peacefully%20by%20a%20sunlit%20window%20with%20a%20cup%20of%20tea%20and%20a%20journal%20soft%20natural%20lighting%20gentle%20warm%20cream%20and%20beige%20tones%20minimal%20elegant%20interior%20feeling%20of%20self%20care%20and%20inner%20peace%20editorial%20photography%20with%20soft%20focus%20and%20dreamy%20atmosphere&width=1200&height=600&seq=article-self-love-01&orientation=landscape',
    tags: ['爱自己', '自我成长', '情感健康', '心理健康'],
  },
  {
    slug: 'the-courage-to-love-deeply',
    title: '全力以赴去爱一个人的勇气',
    excerpt: '爱一个人需要勇气，而"狠狠爱"则需要更大的勇气。当你决定不留退路、不设防备地去爱时，你收获的将不只是爱情，还有生命中最为珍贵的体验。',
    content: `<p>你有没有试过，不顾一切地去爱一个人？</p>
<h2>什么阻挡了我们狠狠爱？</h2>
<p>在成年人的世界里，"爱"这件事变得越来越复杂。我们担心受伤、担心付出没有回报、担心对方不够爱自己。于是我们学会了给自己留退路——不全心投入，不全盘托出。</p>
<p>但正是这些防线，让我们错过了爱最本质的美好。狠狠爱，意味着拆掉这些墙，以最真实的自己去面对另一个人。</p>
<h2>真实的爱情需要勇敢</h2>
<p>当你决定全力以赴去爱的时候，你会发现世界其实并没有你想象中那么可怕。就像跳进一池未知的水，你可能会呛到，但你也可能会发现自己在游泳。</p>
<p>狠狠爱的勇气，不是与生俱来的。它来自于你对自己足够的信任——相信自己即使受伤了也能站起来，相信自己的爱足够强大，可以承受任何结果。</p>
<h2>狠狠爱的五个信号</h2>
<h3>1. 你不害怕展示脆弱</h3>
<p>在对方面前，你愿意分享自己的恐惧、不安和不完美。因为你知道，真正的连接来自于真实的袒露。</p>
<h3>2. 你尊重对方的独立</h3>
<p>狠狠爱不是占有，而是欣赏一个完整的人。你为对方的成就感到骄傲，支持对方追求自己的梦想。</p>
<h3>3. 你愿意为这段关系付出努力</h3>
<p>爱不是一劳永逸的，它需要持续的经营。你愿意花时间倾听、沟通、理解，甚至做出妥协。</p>
<h3>4. 你不计较得失</h3>
<p>真正的爱，不是交易。你付出的每一分，都不以回报为前提。正是这种无私，让爱变得纯粹而强大。</p>
<h3>5. 你在爱中找到了更好的自己</h3>
<p>狠狠爱一个人，最终会把你变成一个更好的人。因为爱让你学会了包容、耐心、勇气和坚持。</p>
<h2>写在最后</h2>
<p>爱得深不深，不在时间长短，而在你是否全力以赴。哪怕只是一段短暂的相遇，只要你是真心以待、毫无保留，那便已经是狠狠爱过了。</p>`,
    category: 'love-someone',
    categoryName: '狠狠爱一个人',
    author: '大宇',
    date: '2026-07-08',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20romantic%20and%20artistic%20scene%20of%20two%20silhouettes%20standing%20on%20a%20cliff%20overlooking%20a%20golden%20sunset%20ocean%20warm%20amber%20and%20rose%20tones%20dramatic%20sky%20with%20soft%20clouds%20feeling%20of%20courage%20and%20deep%20connection%20cinematic%20composition%20with%20atmospheric%20lighting&width=1200&height=600&seq=article-love-courage-02&orientation=landscape',
    tags: ['爱情', '勇气', '深度关系', '情感表达'],
  },
  {
    slug: 'five-love-languages-chinese-way',
    title: '五种深爱表达方式，让你的爱不再沉默',
    excerpt: '爱的表达方式有千万种。在中华文化背景下，我们如何用最真诚的方式向在乎的人传达"我狠狠爱着你"？这五种方式，或许能给你答案。',
    content: `<p>中国人常说"爱在心中口难开"。我们习惯了含蓄，习惯了用行动代替言语。但有时候，爱需要被看见、被听见。</p>
<h2>方式一：用心陪伴，无声胜有声</h2>
<p>陪伴是最长情的告白。在这个人人忙碌的时代，愿意把时间留给一个人，本身就是最深沉的表达。不需要华丽的言辞，只是在对方需要的时候，你恰好在那里。</p>
<p>比如，每周固定安排一次"专属时间"——关掉手机，全心全意地和对方在一起。哪怕只是并肩坐着，也是一种深情的陪伴。</p>
<h2>方式二：用文字记录爱的瞬间</h2>
<p>写一封信，发一段长消息，或者在社交媒体上写下关于对方的点滴。文字有一种神奇的力量，它让瞬间成为永恒。</p>
<p>试着写下你记忆中关于对方最温暖的一个画面，然后告诉对方。你会发现，这些文字比"我爱你"更有力量。</p>
<h2>方式三：用行动诠释关怀</h2>
<p>一锅热汤、一件叠好的衣服、一次默默的接送——这些看似平常的小事，却是最深情的告白。爱不止在轰轰烈烈的大事里，更在日复一日的琐碎关怀中。</p>
<h2>方式四：学会倾听，真正听懂对方</h2>
<p>有时候，最好的表达不是说出什么，而是好好地听。当对方分享快乐时真心祝贺，当对方倾诉烦恼时用心安慰。这种被理解的感觉，比任何礼物都珍贵。</p>
<h2>方式五：用成长来回应爱</h2>
<p>因为爱你，所以我想要成为更好的人。这是最深沉的表达——不是为对方改变自己，而是因为对方的爱而更有动力去成长、去完善自己。</p>
<h2>选择最适合的方式</h2>
<p>每个人接收爱的方式都不一样。有的人需要言语的肯定，有的人需要身体的接触，有的人需要实际的帮助。了解对方的"爱的语言"，用最适合的方式表达，才能让爱被真正接收到。</p>
<p>从今天开始，用这五种方式，狠狠地向你在乎的人表达你的爱吧。</p>`,
    category: 'express-love',
    categoryName: '深爱表达方式',
    author: '小鹿',
    date: '2026-07-01',
    readTime: '12分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20intimate%20scene%20of%20two%20hands%20gently%20holding%20each%20other%20with%20soft%20warm%20lighting%20surrounded%20by%20delicate%20flowers%20and%20handwritten%20letters%20on%20a%20wooden%20table%20cream%20and%20soft%20pink%20tones%20emotional%20and%20tender%20atmosphere%20editorial%20photography&width=1200&height=600&seq=article-love-languages-03&orientation=landscape',
    tags: ['爱的表达', '情感沟通', '亲密关系', '陪伴'],
  },
  {
    slug: 'love-story-grandparents',
    title: '爷爷奶奶的爱情：柴米油盐里的一辈子',
    excerpt: '他们从未说过"我爱你"，却用一生诠释了什么是"狠狠爱"。在平凡的日子里，他们用最朴素的方式，书写了最动人的爱情故事。',
    content: `<p>我的爷爷奶奶结婚六十三年了。</p>
<h2>他们的日常</h2>
<p>每天清晨五点，爷爷会准时起床，去厨房给奶奶熬一碗小米粥。六十三年如一日，从未间断。奶奶总说："你爷爷啊，一辈子就只会熬粥。"但说这话的时候，她的眼里满是温柔。</p>
<p>他们的爱情没有鲜花和钻戒，没有浪漫的旅行和烛光晚餐。有的只是柴米油盐里的互相扶持，是生病时彻夜守在床边的担忧，是争吵后依然默默给对方夹菜的包容。</p>
<h2>爷爷的秘诀</h2>
<p>有一次我问爷爷："您和奶奶在一起这么多年，有什么秘诀吗？"</p>
<p>爷爷想了很久，说了一句让我至今难忘的话："她喜欢吃什么，我就做什么。她不喜欢听的，我就不说。她想做什么，我就陪着她做。就这么简单。"</p>
<p>就是这么简单。可是有多少人，能够一辈子做到呢？</p>
<h2>奶奶的回忆</h2>
<p>奶奶说，年轻的时候家里很穷，两个人挤在一间不到十平米的房子里。冬天冷得发抖，爷爷就把自己的棉袄脱下来给她盖上，自己冻得嘴唇发紫。</p>
<p>"那时候我就知道，这个男人，值得我跟一辈子。"奶奶说。</p>
<h2>爱在细节里</h2>
<p>他们不会说甜言蜜语，但爷爷记得奶奶吃面条不放葱、喝粥要多加糖、怕黑所以晚上一定要有人陪着去厕所。奶奶记得爷爷膝盖不好所以要少走路、喜欢吃咸菜所以要提前腌好、腰疼所以每天要帮忙贴膏药。</p>
<p>这些看似微不足道的细节，堆叠在一起，就是一段跨越半个多世纪的深情。</p>
<h2>他们的"狠狠爱"</h2>
<p>去年奶奶生病住院，八十五岁的爷爷每天坐一个小时的公交车去医院陪她。我劝他休息，他说："她一个人在医院会害怕的。我坐在旁边，哪怕什么都不做，她心里也踏实。"</p>
<p>那一刻我突然明白——"狠狠爱"不一定是炽热燃烧的激情。有时候，它是一种安静而坚定的陪伴，是六十三年不变的粥香，是风雨中始终紧握的手。</p>
<p>谢谢你们，教会了我什么是真正的爱。</p>`,
    category: 'passionate-stories',
    categoryName: '炽烈爱情故事',
    author: '小月',
    date: '2026-06-22',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20elderly%20couple%20sitting%20together%20on%20a%20wooden%20bench%20in%20a%20peaceful%20garden%20bathed%20in%20warm%20golden%20sunset%20light%20holding%20hands%20gently%20surrounded%20by%20autumn%20leaves%20nostalgic%20and%20heartwarming%20atmosphere%20soft%20focus%20cinematic%20photography%20with%20warm%20amber%20and%20cream%20tones&width=1200&height=600&seq=article-grandparents-love-04&orientation=landscape',
    tags: ['爱情故事', '相守一生', '祖辈爱情', '真情'],
  },
  {
    slug: 'grow-through-heartbreak',
    title: '爱过、痛过、然后狠狠成长',
    excerpt: '不是所有的爱都有圆满的结局，但每一段爱都有它的意义。当你从心碎的废墟中站起来时，你会发现，那些伤痛已经变成了你最坚硬的铠甲。',
    content: `<p>失恋是一种什么样的体验？</p>
<p>有人说是天塌了，有人说是心被掏空，有人说再也不会爱了。但我想说——失恋是人生中最深刻的一堂成长课。</p>
<h2>允许自己悲伤</h2>
<p>爱得深，痛得真。当你为一段感情付出了全部，失去的时候当然会痛不欲生。请不要否定这种感受，不要对自己说"振作起来"。</p>
<p>给自己一段时间，去哭、去痛、去回忆、去遗憾。只有完整地经历悲伤，你才能真正地释怀。</p>
<h2>在伤痛中认清自己</h2>
<p>每一次心碎，都是一面镜子。它照出了你最脆弱的地方，也照出了你最渴望的是什么。在那段关系中，你是怎样的一个人？你学到了什么？</p>
<p>我认识一个女孩，她在失恋后发现，自己在这段感情中完全失去了自我。于是她开始重新学习独处，学习一个人吃饭、一个人看电影、一个人旅行。她说："原来一个人也可以过得很精彩。"</p>
<h2>把失去的痛转化为成长的力</h2>
<p>痛苦是有能量的。你可以选择让这股能量吞噬你，也可以选择让它推动你。很多人都是在经历了最深的心碎之后，完成了人生中最大的蜕变。</p>
<p>有人开始健身，有人投入工作，有人学习新技能，有人去旅行看世界。不是因为想要向前任证明什么，而是因为在疗愈自己的过程中，重新发现了生活的无限可能。</p>
<h2>相信时间的力量</h2>
<p>时间不能治愈一切，但它能给你距离。当你有足够的距离回头看时，你会发现——那些曾经让你痛不欲生的日子，如今已经变成了你故事里最有深度的一章。</p>
<h2>重新出发</h2>
<p>当你终于从废墟中站起身来，你会发现自己比想象中要坚强得多。你已经不是以前那个需要依赖别人才能快乐的人了。你学会了爱自己，学会了独立，学会了在风暴中保持镇定。</p>
<p>而当你带着这一身铠甲再次出发时，你会遇到一个同样完整的灵魂，你们不再是互相填补缺口，而是两个完整的圆互相碰撞出更美的火花。</p>
<p>这就是"狠狠爱"之后的"狠狠成长"。</p>`,
    category: 'emotional-growth',
    categoryName: '情感成长之路',
    author: '小羽',
    date: '2026-06-15',
    readTime: '11分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20symbolic%20and%20artistic%20scene%20of%20a%20lone%20figure%20walking%20toward%20a%20bright%20sunrise%20on%20an%20empty%20road%20surrounded%20by%20wildflowers%20transformation%20and%20renewal%20theme%20soft%20warm%20morning%20light%20cream%20and%20gentle%20coral%20tones%20hopeful%20and%20empowering%20atmosphere%20fine%20art%20photography&width=1200&height=600&seq=article-heartbreak-growth-05&orientation=landscape',
    tags: ['情感成长', '失恋', '自我疗愈', '蜕变'],
  },
  {
    slug: 'morning-routine-self-love',
    title: '每天早晨的七个仪式，狠狠宠爱自己',
    excerpt: '一天的开始决定了整天的心情。这七个简单的晨间仪式，不需要花费太多时间，却能让你每一天都感受到被自己深爱着的幸福感。',
    content: `<p>你有没有发现，那些看起来很幸福的人，往往有一些自己坚持的小习惯？</p>
<h2>仪式一：醒来后，先微笑</h2>
<p>不要急着拿起手机。醒来后的第一分钟，给自己一个微笑。哪怕今天有一万件事情等着你去做，这微笑是在告诉你自己："今天，我会好好照顾你。"</p>
<h2>仪式二：喝一杯温水</h2>
<p>经过一夜的睡眠，身体需要补充水分。一杯温水，加一片柠檬或者一小勺蜂蜜，这是你送给身体的第一个礼物。</p>
<h2>仪式三：写下三件感恩的事</h2>
<p>在笔记本上写下三件你感恩的事情。可以是昨天吃到的好吃的，可以是一个朋友的问候，也可以是今天的阳光特别好。这个简单的习惯会潜移默化地改变你看待生活的方式。</p>
<h2>仪式四：对着镜子说一句肯定语</h2>
<p>看着镜子里的自己，真诚地说一句："你很棒，我为你感到骄傲。"起初可能会觉得尴尬，但坚持一周后，你会发现自己对待自己的态度在悄悄改变。</p>
<h2>仪式五：拉伸五分钟</h2>
<p>不需要高强度的运动，只是简单地伸展身体、转动脖子和肩膀。感受身体每一个部位的苏醒，感谢它支撑你度过每一天。</p>
<h2>仪式六：设定今天的"爱自己"目标</h2>
<p>今天你要做一件什么事来宠爱自己？可能是午休时看几页书，可能是拒绝一个不必要的社交，可能只是给自己买一束花。把这个目标写下来，然后去实现它。</p>
<h2>仪式七：深呼吸，然后出发</h2>
<p>在出门之前，做三次深长的呼吸。吸气时，想象自己吸入了一整天的能量和美好；呼气时，释放所有的焦虑和不安。</p>
<h2>坚持的力量</h2>
<p>这些仪式总共只需要二十到三十分钟。但当你坚持一个月后，你会发现自己和以前不一样了——你更从容、更自信、更像一个被深深爱着的人。因为你确实是。</p>`,
    category: 'love-yourself',
    categoryName: '狠狠爱自己',
    author: '小雨',
    date: '2026-06-08',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20bright%20and%20peaceful%20morning%20bedroom%20scene%20with%20soft%20sunlight%20streaming%20through%20sheer%20curtains%20a%20journal%20and%20a%20cup%20of%20tea%20on%20a%20nightstand%20minimal%20cozy%20interior%20with%20warm%20cream%20and%20soft%20beige%20tones%20feeling%20of%20calm%20and%20self%20care%20lifestyle%20photography&width=1200&height=600&seq=article-morning-routine-06&orientation=landscape',
    tags: ['爱自己', '晨间仪式', '生活习惯', '自我关怀'],
  },
  {
    slug: 'love-in-the-digital-age',
    title: '数字时代的狠狠爱：隔着屏幕，也能深情',
    excerpt: '在这个被微信、视频通话和各种社交软件连接的时代，我们如何在数字世界里保持真实而深度的情感连接？',
    content: `<p>有人说，数字时代让感情变得廉价。一条消息只需要几秒钟就能发出，一个表情包就能代替千言万语。但真的是这样吗？</p>
<h2>距离不再是障碍</h2>
<p>在过去，异地恋是一件极其困难的事情——写信要等好几天，电话费贵得离谱。而现在，视频通话让我们可以随时随地看到对方的脸。</p>
<p>但技术的便利，不代表情感的便利。数字时代的狠狠爱，需要我们更加用心。</p>
<h2>用心使用每一个数字工具</h2>
<p>发送一条消息很容易，但发一条用心的消息很难。比起群发的"早安"，不如写一条只针对对方的内容："今天天气转凉了，记得你上次说膝盖会疼，多穿一点。"</p>
<p>这种细节的关注，是数字时代最珍贵的深情。</p>
<h2>创造"共处"的时刻</h2>
<p>即使身处异地，也可以创造共同的体验。同时看一部电影然后讨论，一起在线听同一首歌，或者在视频通话中一起做饭。这些共享的时光，是抵御距离侵蚀感情的良药。</p>
<h2>不要被"已读不回"绑架</h2>
<p>数字时代最大的问题之一，是人们对回复速度的焦虑。请记住，爱不是用回复的速度来衡量的。给对方空间，也给自己空间。真正的安全感，不需要时刻在线来维持。</p>
<h2>数字与现实的结合</h2>
<p>最终的狠狠爱，还是要在现实中落地。在特殊的日子里，不要只发一个红包，写一封信、寄一份用心挑选的礼物。这些实体的、有温度的物件，比任何数字表情都更能传递爱意。</p>`,
    category: 'express-love',
    categoryName: '深爱表达方式',
    author: '小鹿',
    date: '2026-05-28',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20and%20warm%20scene%20of%20a%20smartphone%20showing%20a%20video%20call%20on%20a%20wooden%20desk%20surrounded%20by%20a%20cup%20of%20coffee%20and%20a%20small%20bouquet%20of%20flowers%20soft%20warm%20lighting%20from%20a%20desk%20lamp%20cozy%20evening%20atmosphere%20cream%20and%20amber%20tones%20blending%20technology%20with%20warmth&width=1200&height=600&seq=article-digital-love-07&orientation=landscape',
    tags: ['数字时代', '异地恋', '情感连接', '科技与情感'],
  },
  {
    slug: 'mothers-love-unconditional',
    title: '妈妈的爱：这个世界上最早的"狠狠爱"',
    excerpt: '从我们来到这个世界的那一刻起，就有一个人在不计回报地狠狠爱着我们。那个人就是妈妈。',
    content: `<p>你有多久没有好好跟妈妈说过话了？</p>
<h2>无条件的爱</h2>
<p>这个世界上，很少有爱是完全没有条件的。但妈妈的爱，恰恰就是那极少数的例外。从你还在她肚子里的时候，她就已经开始毫无保留地爱你。</p>
<p>你哭的时候，她是第一个来抱你的人。你生病的时候，她整夜不合眼地守着你。你取得成绩的时候，她比你还要骄傲。</p>
<h2>那些被我们忽略的瞬间</h2>
<p>长大后，我们忙着工作、忙着社交、忙着追逐梦想，渐渐地和妈妈的联系变少了。电话从每天一次变成每周一次，再到"有空的时候再打"。</p>
<p>但妈妈的爱从未减少。她还是会在你生日那天第一个发来祝福，还是会在天气变冷的时候提醒你加衣服，还是会在你发朋友圈说加班的时候，默默地在下面留言："早点休息，别太累。"</p>
<h2>学会回应妈妈的爱</h2>
<p>狠狠爱不只是单向的。我们也要学会"狠狠回应"妈妈的爱。</p>
<p>不需要多么轰轰烈烈——每周固定一个时间打电话，记住她喜欢吃的东西然后寄回去，在节假日回家陪她吃一顿饭。这些微小的回应，对妈妈来说，就是最好的礼物。</p>
<h2>趁还来得及</h2>
<p>有一句话让我每次读到都忍不住落泪："子欲养而亲不待。"</p>
<p>不要等到失去了才后悔没有好好爱过。从今天开始，给妈妈打一个电话，告诉她："妈妈，谢谢你一直以来的爱。我也会狠狠地爱你。"</p>`,
    category: 'passionate-stories',
    categoryName: '炽烈爱情故事',
    author: '大宇',
    date: '2026-05-20',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20tender%20and%20emotional%20scene%20of%20a%20mother%20gently%20holding%20her%20childs%20hand%20in%20a%20sunlit%20kitchen%20warm%20golden%20light%20streaming%20through%20the%20window%20homemade%20food%20on%20the%20table%20nostalgic%20and%20heartwarming%20atmosphere%20cream%20and%20soft%20amber%20tones%20documentary%20style%20photography&width=1200&height=600&seq=article-mother-love-08&orientation=landscape',
    tags: ['母爱', '亲情', '无条件', '感恩'],
  },
  {
    slug: 'self-worth-beyond-relationships',
    title: '在爱别人之前，先找到自己的价值',
    excerpt: '很多人在感情中迷失了自我，把全部的价值感都建立在伴侣的认可上。但真正健康的爱，是两个完整的人相遇，而不是两个半个人拼凑。',
    content: `<p>你有没有在感情中迷失过自己？</p>
<h2>依赖不是爱</h2>
<p>很多人把依赖误解为爱。当一个人说"没有你我活不下去"的时候，这不是爱，而是情感绑架。健康的爱，建立在两个独立的个体之上。</p>
<p>如果你在一段关系中感到焦虑、不安、总是害怕失去对方——这往往不是因为对方不够好，而是因为你没有建立起自己的内在价值感。</p>
<h2>找到自己的节奏</h2>
<p>在一段关系之外，你是谁？你有什么梦想？你喜欢做什么？你有什么价值？</p>
<p>如果你对这些问题没有清晰的答案，那么你需要暂时停下来，先去认识自己。去探索你的兴趣，去发展你的事业，去建立你的朋友圈。</p>
<h2>完整的爱不需要"填补"</h2>
<p>一个完整的人，不会指望另一个人来填补自己的空虚。两个人在一起，不是因为彼此需要，而是因为彼此选择。</p>
<p>当你足够完整的时候，你的爱会变得更加自由——你不会因为害怕失去而委曲求全，不会因为需要认可而失去自我。</p>
<h2>狠狠爱的前提</h2>
<p>在你能够狠狠爱别人之前，请先狠狠地爱上自己的生活。找到让你热血沸腾的事业，培养让你沉浸其中的爱好，建立给你支持和力量的人际关系。</p>
<p>当你的生活本身就已经足够精彩时，爱情会成为锦上添花的美好，而不是救命稻草般的必需。</p>`,
    category: 'emotional-growth',
    categoryName: '情感成长之路',
    author: '小羽',
    date: '2026-05-12',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20confident%20person%20standing%20alone%20on%20a%20hilltop%20overlooking%20a%20beautiful%20landscape%20at%20golden%20hour%20arms%20slightly%20open%20feeling%20free%20and%20empowered%20warm%20golden%20sunlight%20cream%20and%20soft%20coral%20tones%20inspirational%20and%20liberating%20atmosphere%20fine%20art%20photography&width=1200&height=600&seq=article-self-worth-09&orientation=landscape',
    tags: ['自我价值', '独立性', '情感健康', '个人成长'],
  },
  {
    slug: 'friendship-is-another-form-of-love',
    title: '友情也是一种狠狠爱：那些陪你走过风雨的朋友',
    excerpt: '爱情故事总是被反复歌颂，但那些在深夜里接你电话、在你最需要的时候出现的朋友，同样值得被狠狠珍惜。',
    content: `<p>你有没有一个朋友，在你最崩溃的时候，二话不说就出现在你面前？</p>
<h2>友情的重量</h2>
<p>在谈论"狠狠爱"的时候，我们总是不自觉地聚焦于爱情和亲情。但友情，那些彼此选择成为彼此生命中重要一部分的关系，同样需要我们"狠狠"去经营。</p>
<p>真正的朋友，是在你成功时真心为你高兴、在你失落时默默陪在身边的人。你们可能几个月不见面，但一见面仍然无话不谈。</p>
<h2>狠狠珍惜朋友的方式</h2>
<h3>主动联系</h3>
<p>不要总是等着对方来找你。好的友情需要双向的付出。每个月主动约朋友出来吃顿饭，或者在微信上分享一件有趣的事。</p>
<h3>真诚倾听</h3>
<p>当朋友向你倾诉时，放下手机，认真地看着对方，用心地去听。很多时候，人们需要的不是建议，而是被理解的感受。</p>
<h3>记住重要的日子</h3>
<p>朋友的生日、重要的纪念日——这些小小的仪式感，是友情最好的润滑剂。不需要昂贵的礼物，一条用心编写的祝福就够了。</p>
<h3>在需要的时候站出来</h3>
<p>真正的友情，在苦难面前才见真章。可能是深夜的一通电话，可能是一次紧急的搬家帮忙，可能是在对方人生低谷时的默默陪伴。这些时刻，就是"狠狠爱"友情的时刻。</p>
<h2>友情的永恒价值</h2>
<p>爱情可能会来可能会走，但真挚的友情往往陪伴我们走过人生中最多变的岁月。那些一起哭过笑过的朋友，是我们生命中最宝贵的财富之一。</p>
<p>从今天开始，给你最好的朋友发一条消息，告诉ta："谢谢你一直在我身边。我真的很珍惜你。"</p>`,
    category: 'emotional-growth',
    categoryName: '情感成长之路',
    author: '小月',
    date: '2026-05-05',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20close%20friends%20laughing%20together%20on%20a%20cozy%20couch%20in%20a%20warm%20living%20room%20with%20soft%20evening%20light%20streaming%20through%20the%20window%20genuine%20joy%20and%20connection%20cream%20and%20warm%20beige%20tones%20candid%20lifestyle%20photography%20with%20natural%20expressions&width=1200&height=600&seq=article-friendship-10&orientation=landscape',
    tags: ['友情', '珍惜', '人际关系', '陪伴'],
  },
];